import React from 'react';
import { Separator } from './ui/separator';
import { ExternalLink } from 'lucide-react';

const Footer = () => {
  return (
    <footer className="bg-background footer-border">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-12 mb-12">
          <div>
            <img 
              src="https://customer-assets.emergentagent.com/job_explore-elsewhere/artifacts/3xxh7ml4_Podcast%20Logo%20Babes%2C%20How%20Did%20You%20Get%20Here%20%284%29.png"
              alt="A Life Elsewhere"
              className="h-16 w-auto mb-4"
            />
            <p className="text-base text-muted-foreground leading-relaxed font-serif italic">
              Real stories of global nomads, immigrants, and dream-chasers who built lives elsewhere.
            </p>
          </div>

          <div>
            <h4 className="font-semibold text-sm mb-4 label-uppercase">Listen</h4>
            <ul className="space-y-3 text-sm text-muted-foreground">
              <li>
                <a href="https://www.youtube.com/@ALifeElsewhere" target="_blank" rel="noopener noreferrer" className="hover:text-primary flex items-center gap-1.5 transition-colors">
                  YouTube <ExternalLink className="w-3 h-3" />
                </a>
              </li>
              <li>
                <a href="https://open.spotify.com/show/0mTR8zCF2PjQ1jsOEvSlsy" target="_blank" rel="noopener noreferrer" className="hover:text-primary flex items-center gap-1.5 transition-colors">
                  Spotify <ExternalLink className="w-3 h-3" />
                </a>
              </li>
              <li>
                <a href="https://podcasts.apple.com/us/podcast/babes-how-did-you-get-here/id1847899846" target="_blank" rel="noopener noreferrer" className="hover:text-primary flex items-center gap-1.5 transition-colors">
                  Apple Podcasts <ExternalLink className="w-3 h-3" />
                </a>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="font-semibold text-sm mb-4 label-uppercase">Connect</h4>
            <ul className="space-y-3 text-sm text-muted-foreground">
              <li>
                <a href="https://www.instagram.com/a_life_elsewhere" target="_blank" rel="noopener noreferrer" className="hover:text-primary flex items-center gap-1.5 transition-colors">
                  Instagram <ExternalLink className="w-3 h-3" />
                </a>
              </li>
              <li>
                <a href="https://www.tiktok.com/@April_Jackson_Show" target="_blank" rel="noopener noreferrer" className="hover:text-primary flex items-center gap-1.5 transition-colors">
                  TikTok <ExternalLink className="w-3 h-3" />
                </a>
              </li>
              <li>
                <button onClick={() => document.getElementById('hero')?.scrollIntoView({ behavior: 'smooth' })} className="hover:text-primary transition-colors">
                  Join WhatsApp Group
                </button>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="font-semibold text-sm mb-4 label-uppercase">Host</h4>
            <p className="text-sm text-muted-foreground leading-relaxed mb-2">
              April Jackson
            </p>
            <p className="text-xs text-muted-foreground leading-relaxed">
              BBC Presenter, Entrepreneur, Former Miss Universe Jamaica
            </p>
          </div>
        </div>

        <Separator className="mb-8" />

        <div className="flex flex-col sm:flex-row justify-between items-center gap-4 text-sm text-muted-foreground">
          <p>
            © {new Date().getFullYear()} A Life Elsewhere. All rights reserved.
          </p>
          <p className="font-mono font-medium">
            New episodes every Monday & Thursday 🌍
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;